import styles from "./Input.module.css";

export default function Input({
    value = "",
    setValue,
    label = "",
    textArea = false,
    error,
    setError,
    disabled = false,
}) {
    const onValueChange = (e) => {
        setValue(e.target.value);
        error && setError(false);
    };

    return (
        <div className={styles.container}>
            <label className={styles.label}>{label}</label>
            {!textArea ? (
                <input
                    className={`${styles.input} ${styles[error && `error`]}`}
                    disabled={disabled}
                    value={value}
                    onChange={onValueChange}
                />
            ) : (
                <textarea
                    className={`${styles.textarea} ${styles[error && `error`]}`}
                    value={value}
                    disabled={disabled}
                    onChange={onValueChange}
                ></textarea>
            )}
        </div>
    );
}
